// Spacing
const drawerWidth = 270;
const notificationCenterWidth = 300;
const RightSideBarWidth = 600;
const MobileBreakpoint = 600;
const tripTableHeight = 'calc(100vh - 300px)';
const tableHeightWithSparkline = 'calc(100vh - 370px)';
const tripSideBarTableHeight = 'calc(100vh - 315px)';
const tableHeightWithSparklinePayment = 'calc(100vh - 420px)';
const tableHeightWithSparklineTab = 'calc(100vh - 384px)';
const tableHeightWithSparklineSingle = 'calc(100vh - 460px)';
const dieselCardTableHeight =  'calc(100vh - 470px)';
export {
  drawerWidth,
  notificationCenterWidth,
  MobileBreakpoint,
  RightSideBarWidth,
  tripTableHeight,
  tableHeightWithSparkline,
  tableHeightWithSparklineSingle,
  tableHeightWithSparklineTab,
  tableHeightWithSparklinePayment,
  tripSideBarTableHeight,
  dieselCardTableHeight
};
